import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { BodySmall } from "@components/base/Typography";
import {
  selectSortOption,
  setSortOption
} from "@features/InsitutionDatabase/resourceSlice";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { AppDispatch } from "src/services/store";

const Sort = () => {
  const dispatch: AppDispatch = useDispatch();

  const sortOption = useSelector(selectSortOption);

  const handleSortChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    dispatch(setSortOption(event.target.value));
  };

  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <hr className='flex-grow border-t border-gray-300' />
      <FormControl margin='dense' size='small' style={{ minWidth: 80 }}>
        <InputLabel id='sort-label'>Sort</InputLabel>
        <Select
          labelId='sort-label'
          id='sortOptions'
          name='sortOptions'
          value={sortOption}
          onChange={handleSortChange}
          label='Sort'
        >
          <MenuItem value='recent'>
            <BodySmall>Recent</BodySmall>
          </MenuItem>
          <MenuItem value='oldest'>
            <BodySmall>Oldest</BodySmall>
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default Sort;
